import PropTypes from 'prop-types'; 
import css from './Statistics.module.css'; 
import { getRandomHexColor } from './utils/GetRandomColor';


export const Statistics = ({ title, stats }) => {
  return (
    <section className={css.statistics}>
      {title && <h2 className={css.title}>{title}</h2>}
      <ul className={css.statList}>
        {stats.map((stat) => {
          return (
            <li
              key={stat.id}
              style={{
                backgroundColor: getRandomHexColor(),
              }}
              className={css.item}
            >
              <span className={css.label}>{stat.label}</span>
              <span className={css.percentage}>{stat.percentage}%</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

  // Typification for the component
Statistics.propTypes = {
  title: PropTypes.string,

  stats: PropTypes.arrayOf(
    
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      percentage: PropTypes.number.isRequired,
    })
  ).isRequired,
};